import { ActionReducerMap } from '@ngrx/store';
import { UIState } from './ui/states/ui.state';
import { uiReducer } from './ui/reducers/ui.reducer';
import { companyReducer } from './company/reducers/company.reducer';
import { CompanyState } from './company/states/company.state';
import { UserState } from './user/states/user.state';
import { userReducer } from './user/reducers/user.reducer';
import { NotificationState } from './notification/states/notification.state';
import { notificationReducer } from './notification/reducers/notification.reducer';
import { AuthState, loginReducer } from '../auth';

export interface IAppState {
    company: CompanyState;
    user: UserState;
    ui: UIState;
    notification: NotificationState;
    auth: AuthState;
}

export const appReducer: ActionReducerMap<IAppState> = {
    company: companyReducer,
    user: userReducer,
    ui: uiReducer,
    notification: notificationReducer,
    auth: loginReducer
};
